import type { PageContent } from "../types";

export const cookies: PageContent = {
  slug: "cookies",
  title: `Cookie Policy | Phil Carr`,
  description: `Read the Phil Carr cookie policy to understand how cookies are used on this website, what they do, and how you can manage them.`,
  body: `# Cookie Policy

This cookie policy explains what cookies are, how we use them, and
the options available to you when visiting the Phil Carr website. Optional analytics and
marketing cookies are used only if you accept them in the cookie choices panel.

## What Are Cookies?

Cookies are small text files stored on your device when you visit a
website. They help websites remember your preferences, improve performance, and provide
insights into how visitors use the site.

## How We Use Cookies

I use cookies to keep the website running smoothly, understand how
visitors navigate the site, and improve the overall experience. Cookies may be set by
the site or by trusted third-party services that support analytics and performance.

## Types of Cookies We Use

- **Essential cookies** – required for core site functionality such as
navigation and security.
- **Performance cookies** – help us understand how visitors interact with
the site so content and usability can be refined.
- **Functionality cookies** – remember choices like your preferred
settings to provide a more personalised experience.

## Optional measurement cookies

You can choose analytics and advertising separately. If you accept analytics, Google
Analytics 4 may set cookies to measure website visits and content performance. If you
accept advertising, Google Ads may set cookies to measure advertising performance.
Each optional tag loads only after you accept its category. Rejecting either category
does not stop you using the website or sending an enquiry. Use **Cookie settings** at
the bottom of any page to change your choices. Rejecting later stops this site's tags
for that category from sending new events. You can clear existing optional cookies
through your browser settings.

## Website chat cookie

When website chat is available, the essential WEBSITECHAT cookie keeps your conversation separate from other visitors and protects chat submissions. It expires after one day, although the server session may expire sooner. The cookie contains a random session reference, not your messages or contact details. Deleting or blocking it can prevent you from returning to the same conversation. Chat messages remain subject to the retention period in our [privacy policy](/privacy-policy).

## Managing Your Cookie Preferences

Use **Cookie settings** at the bottom of any page to accept or reject optional cookies.
You can also control or delete cookies through your browser settings. Most
browsers allow you to refuse cookies or alert you when cookies are being used. Please
note that disabling cookies may affect the functionality of certain parts of the
website.

## Contact

If you have questions about this cookie policy, please get in touch
at [info@phil-carr.co.uk](mailto:info@phil-carr.co.uk) or call
[01226 697 325](tel:+441226697325).

_Last updated: September 2026_

[Back to Top](/#top)`,
};
